import { novelAdminHttp } from './http.js'

export function listStoryAnimatedCovers() {
  return novelAdminHttp().get('/animated-covers', { routeId: 'novel.admin.animatedCovers.list' })
}

export async function uploadStoryAnimatedCover(slug, file) {
  const data_base64 = await new Promise((resolve, reject) => {
    const reader = new window.FileReader()
    reader.onerror = () => reject(new Error('request_failed'))
    reader.onload = () => resolve(String(reader.result).split(',')[1])
    reader.readAsDataURL(file)
  })
  return novelAdminHttp().put(`/animated-covers/${encodeURIComponent(slug)}`, {
    body: { data_base64 }, routeId: 'novel.admin.animatedCovers.upload',
  })
}

export function setStoryAnimatedCoverEnabled(slug, enabled) {
  return novelAdminHttp().patch(`/animated-covers/${encodeURIComponent(slug)}`, {
    body: { enabled }, routeId: 'novel.admin.animatedCovers.toggle',
  })
}
